import {
  Avatar,
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import AppContainer from "../../../components/containers/AppContainer";
import CustomBar from "../../../components/customBar";
import NavigationDrawer from "../../../components/navigationDrawer";
import TextInput from "../../../components/textInput";
import { useLocation } from "react-router-dom";

const JobSeekerDetails = () => {
  const { state } = useLocation();

  // const { user } = state;

  return (
    <NavigationDrawer>
      <CustomBar title="JOB SEEKER DETAILS" />
      <AppContainer styleProps={{ p: 3 }}>
        <Typography variant="h6" fontWeight="bold" mb={2}>
          Personal Information
        </Typography>

        <Grid container spacing={3} alignItems="center">
          <Grid
            item
            xs={12}
            sm={12}
            md={2}
            display="flex"
            justifyContent="center"
          >
            <Box
              textAlign="center"
              display="flex"
              flexDirection="column"
              justifyContent="center"
              sx={{
                alignItems: "center",
              }}
            >
              <Avatar
                src={state?.image}
                sx={{ width: 120, height: 120, mb: 1 }}
              />
              <Typography variant="h6" fontWeight="bold">
                {state?.jobSeekerId?.firstname} {state?.jobSeekerId.lastname}
              </Typography>
              <Typography variant="body2" fontSize={12} color="text.secondary">
                {state?.jobSeekerId?.email}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={9}>
            <CardContent>
              <Grid container spacing={2}>
                {[
                  { label: "First Name", value: state?.jobSeekerId.firstname },
                  { label: "Last Name", value: state?.jobSeekerId.lastname },
                  { label: "Em", value: state?.jobSeekerId.email },
                  // { label: "Location", value: user.location },
                ].map((item, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <Typography variant="subtitle2" fontWeight="bold">
                      {item.label}
                    </Typography>
                    <TextInput value={item.value} disabled={true} />
                  </Grid>
                ))}
              </Grid>
            </CardContent>
          </Grid>
        </Grid>
      </AppContainer>
    </NavigationDrawer>
  );
};

export default JobSeekerDetails;
